import { cn } from '@/utils'
export const ExplodeIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-gray-800', className)}
    >
      <path
        d="M4 17.2459V10.1146C4 9.82841 4.29742 9.63926 4.5566 9.76061L9.73721 12.1863C10.0806 12.3471 10.3 12.692 10.3 13.0712V20.3674C10.3 20.6579 9.99423 20.8469 9.73435 20.717L4.54015 18.1199C4.20911 17.9544 4 17.616 4 17.2459Z"
        stroke="#1E1E1E"
        strokeWidth="1.62"
      />
      <path
        d="M4 17.2459V10.1146C4 9.82841 4.29742 9.63926 4.5566 9.76061L9.73721 12.1863C10.0806 12.3471 10.3 12.692 10.3 13.0712V20.3674C10.3 20.6579 9.99423 20.8469 9.73435 20.717L4.54015 18.1199C4.20911 17.9544 4 17.616 4 17.2459Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.62"
      />
      <path
        d="M19.75 17.2459V9.93905C19.75 9.64686 19.4411 9.45798 19.181 9.59115L14.0283 12.2295C13.7037 12.3957 13.4987 12.7288 13.4965 13.0935L13.4537 20.3632C13.452 20.6548 13.7586 20.8455 14.0194 20.7151L19.2098 18.1199C19.5409 17.9544 19.75 17.616 19.75 17.2459Z"
        stroke="#1E1E1E"
        strokeWidth="1.62"
      />
      <path
        d="M19.75 17.2459V9.93905C19.75 9.64686 19.4411 9.45798 19.181 9.59115L14.0283 12.2295C13.7037 12.3957 13.4987 12.7288 13.4965 13.0935L13.4537 20.3632C13.452 20.6548 13.7586 20.8455 14.0194 20.7151L19.2098 18.1199C19.5409 17.9544 19.75 17.616 19.75 17.2459Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.62"
      />
      <path
        d="M5.2121 6.06581L11.3685 3.19284C11.6304 3.07061 11.933 3.07061 12.1949 3.19284L18.3513 6.06581C18.6521 6.20617 18.6521 6.63383 18.3513 6.77419L12.1949 9.64716C11.933 9.76939 11.6304 9.76939 11.3685 9.64716L5.2121 6.77419C4.91134 6.63383 4.91134 6.20617 5.2121 6.06581Z"
        stroke="#1E1E1E"
        strokeWidth="1.62"
      />
      <path
        d="M5.2121 6.06581L11.3685 3.19284C11.6304 3.07061 11.933 3.07061 12.1949 3.19284L18.3513 6.06581C18.6521 6.20617 18.6521 6.63383 18.3513 6.77419L12.1949 9.64716C11.933 9.76939 11.6304 9.76939 11.3685 9.64716L5.2121 6.77419C4.91134 6.63383 4.91134 6.20617 5.2121 6.06581Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.62"
      />
    </svg>
  )
}
